import { Button, Stack } from '@mui/material';
import { useState } from 'react';
import { useParams } from 'react-router-dom';

import { useApiKeys } from '@/hooks/useApiKeys';
import theme from '@/theme';

import ApiKeysTable from './components/ApiKeysTable';
import GenerateApiKeyDialog from './components/GenerateApiKeyDialog';

function SystemAccessTab() {
  const { id } = useParams<{ id: string }>();
  const organizationId = parseInt(id ?? '0', 10);

  const { apiKeys, isLoading, isRefetching, error } = useApiKeys(organizationId);

  const [isOpened, setIsOpened] = useState<boolean>(false);

  const openApiDialog = () => {
    setIsOpened(true);
  };

  const handleClose = () => {
    setIsOpened(false);
  };

  return (
    <>
      <Stack direction='column' spacing={1}>
        <Stack sx={{ justifyContent: 'flex-end', alignItems: 'flex-end' }}>
          <Button
            variant='contained'
            data-testid='generate-api-key-button'
            sx={{
              height: '36px',
              fontSize: '14px',
              boxShadow: 'none',
              textTransform: 'none',
              fontWeight: theme.hhglobal.typography.fontWeights.regular,
              '&:active': {
                backgroundColor: theme.hhglobal.neutral.gray900,
                color: theme.palette.common.white,
              },
              '&:disabled': {
                backgroundColor: theme.hhglobal.neutral.gray600,
                color: theme.palette.common.white,
              },
            }}
            onClick={openApiDialog}
            loading={isLoading || isRefetching}
            disabled={isLoading || isRefetching}
          >
            Generate API Key
          </Button>
        </Stack>
        <ApiKeysTable apiKeys={apiKeys} isLoading={isLoading} isRefetching={isRefetching} error={error} organizationId={organizationId} />
      </Stack>
      {isOpened && (
        <GenerateApiKeyDialog open={isOpened} onClose={handleClose} organizationId={organizationId} isRefetching={isRefetching} />
      )}
    </>
  );
}

export default SystemAccessTab;
